import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getOrganisationalStructure } from "../../../store/organisationalSlice";
import PersonSwiper from "./PersonSwiper";

const Second = () => {
    const { t } = useTranslation();
    const [sliders, setSliders] = useState({ first: [], second: [], third: [] });
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getOrganisationalStructure()).then((e) => {
            const firstSwiper = [];
            const secondSwiper = [];
            const thirdSwiper = [];

            e?.payload?.forEach(person => {
                if (person.position === "President" || person.position === "Vice President" || person.position === "Director") {
                    firstSwiper.push(person);
                } else if (person.position === "Academic Council") {
                    secondSwiper.push(person);
                } else if (person.position === "Selection Committee") {
                    thirdSwiper.push(person);
                }
            });

            setSliders({ first: firstSwiper, second: secondSwiper, third: thirdSwiper });
        });
    }, [dispatch]);

    return (
        <>
            <PersonSwiper 
                data={sliders.first} 
                title={t('organizational.board')} 
                className={'flex-center'}
            />
            <PersonSwiper 
                data={sliders.second} 
                inx={'1'} 
                title={t('organizational.academic_council')} 
                nav={true}
            />
            <PersonSwiper 
                data={sliders.third} 
                inx={'2'} 
                title={t('organizational.selection_committee')} 
                nav={true}
            />
        </>
    );
};

export default Second;